module.exports = __webpack_public_path__ + "static/img/11.db9f7aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/sp/11.png
// module id = QzJ6
// module chunks = 0